export class ProductsParameters {
    from: Date;
    to: Date;
    productSku?: string;
    serialNumber: string;
    yesCPO?: boolean;
    noCPO?: boolean;
    isUsed?: boolean = false;
    selectedTimeRange: string;
}